import { type ErrorType, apiRequest } from "../api";

export interface VapidPublicKeyResponse {
  publicKey: string;
}

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export const pushService = {
  async getVapidPublicKey(): Promise<[VapidPublicKeyResponse | null, ErrorType | null]> {
    return apiRequest<VapidPublicKeyResponse>({
      loaderKey: "pushVapidPublicKey",
      method: "get",
      url: "/app/push/vapid-public-key",
    });
  },

  async subscribe(payload: PushSubscriptionPayload): Promise<[{ success: boolean } | null, ErrorType | null]> {
    return apiRequest<{ success: boolean }>({
      loaderKey: "pushSubscribe",
      method: "post",
      url: "/app/push/subscribe",
      data: payload,
    });
  },

  async unsubscribe(endpoint: string): Promise<[{ success: boolean } | null, ErrorType | null]> {
    return apiRequest<{ success: boolean }>({
      loaderKey: "pushUnsubscribe",
      method: "delete",
      url: "/app/push/subscribe",
      data: { endpoint },
    });
  },
};
